export default __webpack_public_path__ + "static/lframe-about-us-cc55b5b76248ddb82dad193bd02f0e04.png";